import { GlobalStateType } from './GlobalState';

export const initialGlobalStateValues: GlobalStateType = {
  AppStore: {},
  Question: {},
  Product: {},
};

export default function getInitialGlobalStateValues(): GlobalStateType {
  return {
    ...initialGlobalStateValues,
  };
}
